<div class="bg-white">
  <h3 class="border-bottom p-4">
    <span>{{'Add new Business' |translate}}</span>
  </h3>
  <form *ngIf="newBusinessForm" [formGroup]="newBusinessForm" class="p-4">
    <div class="form-group row">
      <div class="col-12 col-sm-6 mb-3">
        <label>{{'Business Name' |translate}}</label>
        <input type="text" formControlName="newBusinessName" placeholder="{{'Business Name' |translate}}" class="form-control">
        <div class="text-danger" *ngIf="formValidator.formErrors.firstName">
          {{ formValidator.formErrors.businessName }}
        </div>
      </div>
    </div>

    <mat-hint *ngIf="error" style="color:red" class="d-flex">
     <mat-icon>error</mat-icon> {{ errorMsg }}
    </mat-hint>
    <div class="d-flex justify-content-end">
      <button class="btn btn-primary" (click)="onSubmit()" *ngIf="newBusinessForm" [disabled]="newBusinessForm.invalid">
        {{ 'Sellers.Products.Submit' | translate }}
      </button>
    </div>
  </form>
</div>
